const INITIAL_STATE = {
  showButtons: 0
};

export const coffeeHomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_COFFEE_BUTTONS':
      return {
        ...state,
        showButtons: action.payload
      };
    default:
      return state;
  }
};
